import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Media from './components/Media';
import AppSection from './components/AppSection';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Faq from './components/Faq';
import Carousel from './components/Carousel';
import Topics from './components/Topics';
import About from './components/About';
import Updates from './components/Updates';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Media />
        <AppSection />
        <Cards />
        <Contact />
        <Faq />
        <Carousel />
        <Topics />
        <About />
        <Updates />
        <Comments />
        <Ranking />
        <Index />
      </main>
      <Footer />
    </div>
  );
}